import {optimizelyUserId} from '@s-ui/segment-wrapper/lib/middlewares/source/optimizelyUserId'

import setGaCustomProperties from './setGaCustomProperties/index.js'

// Set shared source middlewares.
export default [optimizelyUserId, setGaCustomProperties]
